var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"name":("process[" + (_vm.field.nombre) + "]"),"color":"success"},on:{"click":_vm.downloadDocument}},[_vm._v(" "+_vm._s(_vm.field.etiqueta)+" "),_c('v-icon',{attrs:{"small":"","right":""}},[_vm._v("fas fa-download")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }